import { createFilter } from '@spotify/confidence-core-react';

import { TypeFilterEditor } from './TypeFilterEditor';
import { TypeFilterViewer } from './TypeFilterViewer';

export const typeIdToParentQuery = (id: string): string =>
  id === 'analysis'
    ? '(parent:"workflows/analysis" OR parent:"workflows/reanalysis")'
    : `parent:"workflows/${id}"`;

const typeFilterQuery = (value: string[]): string => {
  if (!value || value.length === 0) return '';
  return value.map(typeIdToParentQuery).join(' OR ');
};

export const TYPE_FILTER = createFilter<string[]>({
  id: 'type',
  label: 'Type',
  query: typeFilterQuery,
  viewer: TypeFilterViewer,
  editor: TypeFilterEditor,
});
